var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"image-container",attrs:{"as":"span"}},[_c('img',_vm._b({ref:"resizableImg",attrs:{"draggable":_vm.isDraggable,"data-drag-handle":_vm.isDraggable}},'img',_vm.node.attrs,false)),_c('b-icon',{ref:"icon",staticClass:"resize-icon hidden",attrs:{"icon":"arrows-move"},on:{"mousedown":_vm.onMouseDown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }